import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-14">
          <div>
            <SectionHeading
              index="07"
              title="新手指南 · 常见问题"
              desc="第一次接触这类平台，先把这些问题弄清楚，浏览起来会顺很多。"
            />
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className="ri-customer-service-2-line text-lg"></i>
              </span>
              <p className="text-sm leading-relaxed text-foreground-600">
                还有别的疑问？可在页脚「意见反馈」处留言，我们会持续补充到这份指南里。
              </p>
            </div>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 font-heading text-sm font-bold text-accent-500">
                        Q{index + 1}
                      </span>
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${
                        isOpen
                          ? "bg-primary-100 text-primary-700"
                          : "bg-background-100 text-foreground-500"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-4 pb-5 md:px-6 md:pl-[3.25rem]">
                      <p className="text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}